export default __webpack_public_path__ + "media/icons/caret-473cf8fa.svg";